import React, { useEffect, useState } from 'react';
import axios from 'axios';
import clsx from 'clsx';
import { useHistory, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent, TextField } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import { Multiselect } from 'multiselect-react-dropdown';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';
import ButtonComp from '../../../components/button/index';
import { CommonConfig } from '../../../config/common-config';
import '../ultimatestyles.css';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../components/loaderpopup/success';
import ErrorPopUp from '../../../components/loaderpopup/error';
import PreviewImage from '../../../assets/previewImage.png';
import PreviewModal from '../../../components/modal/previewModal';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles((theme) => ({
    submit: {
        margin: theme.spacing(3, 0, 2),
        background: '#f8961d',
        '&:hover': {
            background: '#fdac48',
        },
        border: '1px solid #ef8400',
        borderRadius: '5px',
        fontFamily: 'Rubik',
        width: '50%',
        color: '#fff',
    },
    centerAlign: {
        textAlign: 'center',
    },
    btnFieldPositionRight: {
        position: 'absolute',
        right: '0',
        top: '20px',
    },
    uploadBtn: {
        width: '30px',
        fontSize: '10px !important',
        height: '20px',
        textTransform: 'capitalize',
        fontWeight: '400 !important',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        marginTop: '0px',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    disableBtn: {
        color: '#bbb !important',
        background: '#cecece !important',
        padding: '6px 40px !important',
        fontFamily: 'Rubik',
        textTransform: 'none !important',
    },
    textField: {
        borderBottom: '1px solid lightgrey !important',
    },
}));

export default function IndividualCreate(props) {
    const classes = useStyles();
    const location = useLocation();
    const [allStates, setAllStates] = useState([]);
    const [allCities, setAllCities] = useState([]);
    const [allCountries, setAllCountries] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [fileuploadMsgError, setFileuploadMsgError] = useState([]);
    const [otpDiv, setotpDiv] = useState('none');
    const [isDisableClose, setIsDisableClose] = useState(true);
    const [isDisable, setIsDisable] = useState(true);
    const [isDisableCancel, setIsDisableCancel] = useState(true);
    const [isDisableAddFile, setIsDisableAddFile] = useState(true);
    const [isDisableSubmit, setIsDisableSubmit] = useState(true);
    const [length, setLength] = useState('');
    const [lengthSuccess, setLengthSuccess] = useState('');
    const [fileuploadMsg400Error, setFileuploadMsg400Error] = useState('');
    const [isfileInvalid, setIsfileInvalid] = useState('');
    const [filename, setFilename] = useState('');
    const [clearData, setClearData] = useState('');
    const [handleOpen, setHandleOpen] = useState(false);
    const [selectedFileData, setSelectedFileData] = useState(null);
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    const [catchErrorDiv, setCatchErrorDiv] = useState('none');
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const [errormsg, setErrormsg] = useState('');
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.userType;
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails.tennantName;
    // const IMCname = usertype === 'SUPERADMIN' ? location.state.domainname : dbname
    const [selectedImc, setselectedImc] = useState('');
    const [domainname, setDomainName] = useState('');
    const [selectedCountry, setselectedCountry] = useState('');
    const [selectedState, setselectedState] = useState('');
    const [selectedStateId, setselectedStateId] = useState('');
    const [selectedCity, setselectedCity] = useState('');
    const [handleOpenPan, setHandleOpenPan] = useState(false);
    const [clearDataPan, setClearDataPan] = useState('');
    const [isfileInvalidPan, setIsfileInvalidPan] = useState('');
    // console.log('isfileInvalidPanTest', isfileInvalidPan);
    // const [isDisableAttachDocBtn, setisDisableAttachDocBtn] = useState(true);
    const [selectedFileDataPan, setSelectedFileDataPan] = useState(null);
    const [filenamePan, setFilenamePan] = useState('');
    const [uploadSuccessfullyPan, setUploadSuccessfullyPan] = useState('');
    const [isDisablePan, setIsDisablePan] = useState(true);
    const [URLValuePan, setURLValuePan] = useState();
    const [handleOpenAadhar, setHandleOpenAadhar] = useState(false);
    const [clearDataAadhar, setClearDataAadhar] = useState('');
    const [isfileInvalidAadhar, setIsfileInvalidAadhar] = useState('');
    const [selectedFileDataAadhar, setSelectedFileDataAadhar] = useState(null);
    const [filenameAadhar, setFilenameAadhar] = useState('');
    const [uploadSuccessfullyAadhar, setUploadSuccessfullyAadhar] = useState('');
    const [isDisableAadhar, setIsDisableAadhar] = useState(true);
    const [URLValueAadhar, setURLValueAadhar] = useState();
    const [URLValueEnrollment, setURLValueEnrollment] = useState();
    const [handleOpenGst, setHandleOpenGst] = useState(false);
    const [clearDataGst, setClearDataGst] = useState('');
    const [isfileInvalidGst, setIsfileInvalidGst] = useState('');
    const [selectedFileDataGst, setSelectedFileDataGst] = useState(null);
    const [filenameGst, setFilenameGst] = useState('');
    const [uploadSuccessfullyGst, setUploadSuccessfullyGst] = useState('');
    const [isDisableGst, setIsDisableGst] = useState(true);
    const [URLValueGst, setURLValueGst] = useState();
    const [handleOpenReg, setHandleOpenReg] = useState(false);
    const [clearDataReg, setClearDataReg] = useState('');
    const [isfileInvalidReg, setIsfileInvalidReg] = useState('');
    const [selectedFileDataReg, setSelectedFileDataReg] = useState(null);
    const [filenameReg, setFilenameReg] = useState('');
    const [uploadSuccessfullyReg, setUploadSuccessfullyReg] = useState('');
    const [isDisableReg, setIsDisableReg] = useState(true);
    const [URLValueReg, setURLValueReg] = useState();
    const [URLValue, setURLValue] = useState();
    const [handleOpenNew, setHandleOpenNew] = useState(false);
    const [clearDataNew, setClearDataNew] = useState('');
    const [isfileInvalidNew, setIsfileInvalidNew] = useState('');
    const [selectedFileDataNew, setSelectedFileDataNew] = useState(null);
    const [filenameNew, setFilenameNew] = useState('');
    const [uploadSuccessfullyNew, setUploadSuccessfullyNew] = useState('');
    const [isDisableNew, setIsDisableNew] = useState(true);
    const [attachedFilePan, setAttachedFilePan] = useState('');
    const [attachedFileAadhar, setAttachedFileAadhar] = useState('');
    const [attachedFileEnrollment, setAttachedFileEnrollment] = useState('');
    const [visible, setVisible] = React.useState(false);
    const [downloadFile, setDownloadFile] = useState('');
    const prefCommOptions = [{ name: 'Email' }, { name: 'Mobile' }];
    const prefLangOptions = [{ name: 'English' }, { name: 'Kannada' }, { name: 'Hindi' }];
    const [commArr, setCommArr] = useState([]);
    const [commStr, setCommStr] = useState('');
    const [langStr, setLangStr] = useState('');
    const [langArr, setLangArr] = useState([]);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: bearerToken,
        },
    };
    const [values, setValues] = React.useState({
        showPassword: false,
    });
    // const downloadformat = `${CommonConfig.dev.baseUrl}/api/auth/sample-ultimateclientInd`;
    const downloadformat = `${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=ConfigFiles/Individual_clients_creation_format.xlsx`;

    const fetchCountryData = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/getCountries`, axiosConfig)
            .then((response) => {
                setAllCountries(response.data);
            })
            .catch(() => {});
    };
    const fetchStateData = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/country/${data}/getStates`, axiosConfig)
            .then((response) => {
                setAllStates(response.data);
            })
            .catch(() => {});
    };

    const fetchCityData = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/state/${data}/getCities`, axiosConfig)
            .then((response) => {
                setAllCities(response.data);
            })
            .catch(() => {});
    };

    const fetchStateId = (country, state) => {
        if (usertype === 'SUPERADMIN') {
            axios
                .post(
                    `${CommonConfig.dev.baseUrl}/api/auth/state-country/${selectedImc}?state=${state}&country=${country}`,
                    '',
                    axiosConfig
                )
                .then((response) => {
                    setselectedStateId(response.data.state.id);
                });
        } else {
            axios
                .post(`${CommonConfig.dev.baseUrl}/api/auth/state-country/${dbname}?state=${state}&country=${country}`, '', axiosConfig)
                .then((response) => {
                    setselectedStateId(response.data.state.id);
                });
        }
    };

    const setCountry = (e) => {
        setselectedCountry(e.target.value);
        fetchStateData(e.target.value);
    };
    const setState = (e) => {
        setselectedState(e.target.value);
        fetchCityData(e.target.value);
        fetchStateId(selectedCountry, e.target.value);
    };
    const setCity = (e) => {
        setselectedCity(e.target.value);
    };

    useEffect(() => {
        const IMCname = usertype === 'SUPERADMIN' ? location.state.domainname : dbname;
        setselectedImc(IMCname);
        setDomainName(IMCname);
        fetchCountryData();
    }, [bearerToken]);

    const allCountryOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.country_name}>{data.country_name}</option>);
        return OptionList;
    };

    const allStateOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.state_name}>{data.state_name}</option>);
        return OptionList;
    };
    const allCityOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.city_name}>{data.city_name}</option>);
        return OptionList;
    };

    // const allImcsOptions = (vv) => {
    //     const OptionList = vv.map((data) => <option value={data.dbName}>{data.dbName}</option>);
    //     return OptionList;
    // };

    const fileUpload = () => {
        setShowLoader(true);
        const data = new FormData();
        data.append('file', selectedFileData);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/upload_ultimateclientind/${selectedImc}`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    setIsDisableClose(false);
                    setIsDisableAddFile(true);
                    setIsDisableCancel(true);
                    setIsDisableSubmit(false);
                    const failure = [];
                    setShowLoader(false);
                    {
                        response.data.map((row, index) => {
                            if (row.status) {
                                failure.push({ email: row.userEmail, status: row.status, message: row.errormessage });
                                setotpDiv('block');
                            }
                        });
                    }
                    setFileuploadMsgError(failure);
                }
            })
            .catch((error) => {
                if (error && error.response && error.response.data) {
                    setCatchErrorDiv('block');
                    setShowLoader(false);
                    setIsDisableClose(false);
                    setIsDisableAddFile(false);
                    setIsDisableCancel(true);
                    setIsDisableSubmit(true);
                    setFileuploadMsg400Error(`${error.response.data.error} : ${error.response.data.message}`);
                }
            });
    };

    const isFileUpload = (selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv)$');
            setFilename(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalid('');
                setIsDisable(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalid('Please select the file size less than 10MB');
                    setIsDisable(true);
                } else {
                    setSelectedFileData(selectorFiles[0]);
                    setIsDisableClose(true);
                    setIsDisableCancel(false);
                    setIsDisableAddFile(false);
                }
            } else {
                setIsfileInvalid('Please select valid file formate i.e xlsx/xls/csv');
                setIsDisable(true);
            }
        }
    };

    // const handleRoleChange = (event) => {
    //     switch (event.target.value) {
    //         case 'Individual':
    //             history.push('/menu/ClientIndividualCreate');
    //             return true;
    //         case 'Corporate':
    //             history.push('/menu/ClientCorporateCreate');
    //             return true;
    //         default:
    //             return true;
    //     }
    // };

    const handleClick = () => {
        setHandleOpen(true);
        setClearData('');
        setIsDisableClose(false);
        setIsDisableCancel(true);
        setIsDisableAddFile(false);
        setFilename('');
    };

    const handleClose = () => {
        setShowBtnLoader(false);
        setShowLoader(false);
        setHandleOpen(false);
        setIsDisable(true);
        setIsDisableSubmit(true);
        setIsfileInvalid('');
        setotpDiv('none');
        setCatchErrorDiv('none');
        setUploadSuccessfullyAadhar('');
    };
    const handleClosePan = () => {
        setHandleOpenPan(false);
        setIsfileInvalidPan('');
        setUploadSuccessfullyPan('');
    };
    const handleClickPan = () => {
        setHandleOpenPan(true);
        setFilenamePan('');
        setClearDataPan('');
        setIsDisablePan(true);
    };
    const isFileUploadPan = (selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilenamePan(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalidPan('');
                setIsDisablePan(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalidPan('Please select the file size less than 10MB');
                    setIsDisablePan(true);
                } else {
                    setSelectedFileDataPan(selectorFiles[0]);
                }
            } else {
                setIsfileInvalidPan('Please select valid file formate i.e xlsx/xls/csv');
                setIsDisablePan(true);
            }
        }
    };
    const fileUploadPan = () => {
        const data = new FormData();
        data.append('file', selectedFileDataPan);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${dbname}/111/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    setURLValuePan(response.data);
                    setAttachedFilePan(filenamePan);
                    setUploadSuccessfullyPan('Uploaded a file successfully');
                    setTimeout(() => {
                        handleClosePan();
                    }, 500);
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisablePan(true);
                }
            });
    };
    const handleCloseAadhar = () => {
        setHandleOpenAadhar(false);
        setIsfileInvalidAadhar('');
        setUploadSuccessfullyAadhar('');
    };
    const handleClickAadhar = () => {
        setClearDataAadhar('');
        setFilenameAadhar('');
        setIsDisableAadhar(true);
        setHandleOpenAadhar(true);
    };
    const isFileUploadAadhar = (selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilenameAadhar(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalidAadhar('');
                setIsDisableAadhar(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalidAadhar('Please select the file size less than 10MB');
                    setIsDisableAadhar(true);
                } else {
                    setSelectedFileDataAadhar(selectorFiles[0]);
                }
            } else {
                setIsfileInvalidAadhar('Please select valid file formate i.e xlsx/xls/csv');
                setIsDisableAadhar(true);
            }
        }
    };
    const fileUploadAadhar = () => {
        const data = new FormData();
        data.append('file', selectedFileDataAadhar);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${dbname}/111/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    setURLValueAadhar(response.data);
                    setAttachedFileAadhar(filenameAadhar);
                    setUploadSuccessfullyAadhar('Uploaded a file successfully');
                    setTimeout(() => {
                        handleCloseAadhar();
                    }, 500);
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisableAadhar(true);
                }
            });
    };

    const formik = useFormik({
        initialValues: {
            // intclientName: '',
            firstname: '',
            lastname: '',
            addressline1: '',
            addressline2: '',
            city: '',
            state: '',
            country: '',
            pin: '',
            primarycontactname: '',
            designation: '',
            primarymobilenumber: '',
            personalemailid: '',
            pan: '',
            govIDType: 'Aadhaar Number',
            govIDNumber: '',
            enrollmentNo: '',
            gstin: '',
            govtRegNumber: '',
            prefLang: '',
            prefComm: '',
            dob: '',
            website: '',
            dsc1PersonName: '',
            dsc1StartDate: '',
            dsc1EndDate: '',
            dsc1Password: '',
            dsc1Physical: 'YES',
        },
        validationSchema: Yup.object().shape({
            firstname: Yup.string().label('FirstName').required(),
            lastname: Yup.string().label('LastName').required(),
            addressline1: Yup.string().required('Please Enter your Address').max(1000, 'Max 1000 characters or less'),
            addressline2: Yup.string().required('Please Enter your Address').max(1000, 'Max 1000 characters or less'),
            city: Yup.string()
                .matches(/^[aA-zZ ]+$/, 'Enter a valid City')
                .required('Required Field'),
            state: Yup.string().ensure().required('State is Required'),
            country: Yup.string()
                .matches(/^[aA-zZ ]+$/, 'Enter a valid Country')
                .required('Required Field'),
            pin: Yup.string()
                .matches(/^\d{4,6}$/, 'Enter a valid PIN')
                .required('Please enter your PinCode'),
            primarymobilenumber: Yup.string()
                // .matches(/^[0-9]{10,12}$/, 'Enter vaild mobile number')
                .matches(/^\+[1-9]{1}[0-9]{4,11}$/, 'Enter vaild mobile number with valid Country code')
                .required('Enter your Primary Mobile Number'),
            personalemailid: Yup.string()
                .matches(/^[a-zA-Z0-9._-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,63}$/, 'Enter Valid Email')
                .email('Invalid Email Format')
                .required('Required Field'),
            dob: Yup.date().max(new Date(), 'Date of Birth should not be a future date').required('Please Enter your Date Of Birth'),
            pan: Yup.string()
                .matches(/^[aA-zZ]{5}[0-9]{4}[aA-zZ]{1}$/, 'Enter Valid PAN')
                .required('PAN is Mandatory'),
            govIDType: Yup.string(),
            govIDNumber: Yup.string()
                .nullable()
                .when('govIDType', {
                    is: 'Aadhaar Number' || 'Enrollment Number',
                    then: Yup.string()
                        .matches(/^\d{4}\d{4}\d{4}$/, 'Enter Valid 12 digit Aadhaar Number')
                        .required('Aadhaar Number is Mandatory'),
                }),
            enrollmentNo: Yup.string()
                .nullable()
                .when('govIDType', {
                    is: 'Enrollment Number',
                    then: Yup.string()
                        .matches(/^\d{4}\d{5}\d{5}$/, 'Enter Valid 14 digit Enrollment Number')
                        .required('Enrollment Number is Mandatory'),
                }),
            gstin: Yup.string(),
            govtRegNumber: Yup.string(),
            prefComm: commArr.length === 0 ? Yup.string().ensure().required('Required Field') : null,
            prefLang: langArr.length === 0 ? Yup.string().ensure().required('Required Field') : null,
            website: Yup.string(),
            dsc1PersonName: Yup.string(),
            dsc1StartDate: Yup.date(),
            dsc1EndDate: Yup.date().min(Yup.ref('dsc1StartDate'), "Validity end date can't be before validity start date").nullable(),
            dsc1Password: Yup.string(),
            dsc1Physical: Yup.string(),
        }),

        onSubmit: (values) => {
            setShowLoader(true);
            const data = {
                firstName: values.firstname,
                lastName: values.lastname,
                addressId: {
                    addressLine1: values.addressline1,
                    addressLine2: values.addressline2,
                    city: selectedCity,
                    stateId: {
                        id: selectedStateId,
                    },
                    pinCode: values.pin,
                    country: selectedCountry,
                },

                dob: values.dob,
                primarycontMobnumber: values.primarymobilenumber,
                primarycontEmailid: values.personalemailid,
                pan: values.pan,
                panFiles: URLValuePan && URLValuePan.length ? URLValuePan : '',
                aadharNumber: values.govIDNumber,
                adhaarFiles: URLValueAadhar && URLValueAadhar.length ? URLValueAadhar : '',
                prefModecommu: commStr,
                prefLangcommu: langStr,
                tennantName: selectedImc,
                website: values.website,
                gstinNumber: values.gstin,
                gstinFiles: URLValueGst && URLValueGst.length ? URLValueGst : '',
                govRegnumber: values.govtRegNumber,
                dscPersonName: values.dsc1PersonName,
                dscValidityStartdate: values.dsc1StartDate,
                dscValidityEnddate: values.dsc1EndDate,
                dscPassword: values.dsc1Password,
                dscPhysicalAvailability: values.dsc1Physical,
                enrollmentNumber: values.enrollmentNo,
                enrollmentFiles: URLValue && URLValue.length ? URLValue : '',
                doYouHaveAadhaar: values.govIDType,
            };

            // console.log("data", data);

            axios
                .post(`${CommonConfig.dev.baseUrl}/api/auth/s_uclient_Ind`, data, axiosConfig)
                .then((response) => {
                    setShowLoader(false);
                    setSuccessPop(true);
                    setTimeout(() => {
                        usertype === 'SUPERADMIN'
                            ? props.history.push({
                                  pathname: '/menu/individualclientsitec',
                                  state: { domainname },
                              })
                            : props.history.push({
                                  pathname: '/menu/ClientIndividualView',
                              });
                    }, 3000);
                })
                .catch((error) => {
                    const errResult = error.response;
                    if (errResult.data) {
                        setShowLoader(false);
                        setErrorPop(true);
                        setTimeout(() => {
                            setErrorPop(false);
                        }, 5000);
                        setErrorMsgGenerateRecceipt(errResult.data.message);
                    }
                });
        },
    });
    const toInputUppercase = (e) => {
        e.target.value = ('' + e.target.value).toUpperCase();
    };

    // const setImc = (e) => {
    //     setselectedImc(e.target.value);
    //     setisDisableAttachDocBtn(false);
    //     axios
    //         .get(
    //             `${CommonConfig.dev.baseUrl}/api/auth/upload_ultimateclientind/${e.target.value}?page=0&size=100&sort=userId,desc`,
    //             axiosConfig
    //         )
    //         .then((response) => {
    //             setTotalReactPackages(response.data.content);
    //             //console.log(response.data.content);
    //         })
    //         .catch((error) => {
    //             //console.log(error.response.data);
    //             // if (error.response.data) {
    //             //     setisError(error.response.data);
    //             //     setTotalReactPackages([]);
    //             // }
    //         });
    // };

    const handleCloseGst = () => {
        setHandleOpenGst(false);
        setIsfileInvalidGst('');
        setUploadSuccessfullyGst('');
    };
    const handleClickGst = () => {
        setHandleOpenGst(true);
        setClearDataGst('');
        setFilenameGst('');
        setIsDisableGst(true);
    };
    const isFileUploadGst = (selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilenameGst(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalidGst('');
                setIsDisableGst(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalidGst('Please select the file size less than 10MB');
                    setIsDisableGst(true);
                } else {
                    setSelectedFileDataGst(selectorFiles[0]);
                }
            } else {
                setIsfileInvalidGst('Please select valid file formate i.e xlsx/xls/csv');
                setIsDisableGst(true);
            }
        }
    };
    const fileUploadGst = () => {
        const data = new FormData();
        data.append('file', selectedFileDataGst);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${dbname}/111/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    setURLValueGst(response.data);
                    setUploadSuccessfullyGst('Uploaded a file successfully');
                    setTimeout(() => {
                        handleCloseGst();
                    }, 500);
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisableGst(true);
                }
            });
    };
    const handleCloseReg = () => {
        setHandleOpenReg(false);
        setIsfileInvalidReg('');
        setUploadSuccessfullyReg('');
    };
    const handleClickReg = () => {
        setHandleOpenReg(true);
        setClearDataReg('');
        setFilenameReg('');
        setIsDisableReg(true);
    };
    const isFileUploadReg = (selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilenameReg(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalidReg('');
                setIsDisableReg(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalidReg('Please select the file size less than 10MB');
                    setIsDisableReg(true);
                } else {
                    setSelectedFileDataReg(selectorFiles[0]);
                }
            } else {
                setIsfileInvalidReg('Please select valid file formate i.e xlsx/xls/csv');
                setIsDisableReg(true);
            }
        }
    };
    const fileUploadReg = () => {
        const data = new FormData();
        data.append('file', selectedFileDataReg);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${dbname}/111/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    setURLValueReg(response.data);
                    setUploadSuccessfullyReg('Uploaded a file successfully');
                    setTimeout(() => {
                        handleCloseReg();
                    }, 500);
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisableReg(true);
                }
            });
    };

    const handleCloseNew = () => {
        setHandleOpenNew(false);
        setIsfileInvalidNew('');
        setUploadSuccessfullyNew('');
    };
    const handleClickNew = () => {
        setHandleOpenNew(true);
        setClearDataNew('');
        setFilenameNew('');
        setIsDisableNew(true);
    };
    const isFileUploadNew = (selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilenameNew(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalidNew('');
                setIsDisableNew(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalidNew('Please select the file size less than 10MB');
                    setIsDisableNew(true);
                } else {
                    setSelectedFileDataNew(selectorFiles[0]);
                }
            } else {
                setIsfileInvalidNew('Please select valid file formate i.e xlsx/xls/csv');
                setIsDisableNew(true);
            }
        }
    };

    const fileUploadNew = () => {
        const data = new FormData();
        data.append('file', selectedFileDataNew);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${dbname}/111/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    setURLValue(response.data);
                    const filename = response.data.substring(response.data.lastIndexOf('/') + 1);
                    setAttachedFileEnrollment(filename);
                    setUploadSuccessfullyNew('Uploaded a file successfully');
                    setTimeout(() => {
                        handleCloseNew();
                    }, 500);
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisableNew(true);
                }
            });
    };

    function StyledRadio(props) {
        const classes = useStyles();

        return (
            <Radio
                className={classes.root}
                disableRipple
                color="default"
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                {...props}
            />
        );
    }
    const onSelect = (selectedList, selectedItem) => {
        const strComm = selectedList
            .map((data) => {
                return `${data.name}`;
            })
            .join();
        setCommArr([...commArr, selectedItem]);
        setCommStr(strComm);
    };

    const onRemove = (selectedList, removedItem) => {
        commArr.filter(function (item, index) {
            if (item.name === removedItem.name) {
                return commArr.splice(index, 1);
            }
        });
        setCommArr([...commArr]);
        const strComm = commArr
            .map((data) => {
                return `${data.name}`;
            })
            .join();
        setCommStr(strComm);
    };

    const onSelectLang = (selectedList, selectedItem) => {
        const strLang = selectedList
            .map((data) => {
                return `${data.name}`;
            })
            .join();
        setLangArr([...langArr, selectedItem]);
        setLangStr(strLang);
    };

    const onRemoveLang = (selectedList, removedItem) => {
        langArr.filter(function (item, index) {
            if (item.name === removedItem.name) {
                return langArr.splice(index, 1);
            }
        });
        setLangArr([...langArr]);
        const strLang = commArr
            .map((data) => {
                return `${data.name}`;
            })
            .join();
        setLangStr(strLang);
    };

    const handleModalClose = () => {
        setVisible(false);
    };

    const handlePreviewModal = (file) => {
        setDownloadFile(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`);
        setShowBtnLoader(true);
        setTimeout(() => {
            setShowBtnLoader(false);
            setVisible(true);
        }, 1000);
    };

    const back = () => {
        usertype === 'SUPERADMIN'
            ? props.history.push({
                  pathname: '/menu/individualclientsitec',
                  state: { domainname },
              })
            : props.history.push({
                  pathname: '/menu/ClientIndividualView',
              });
    };

    return (
        <>
            {successpop ? (
                <SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title="Client created successfully" />
            ) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />
            ) : null}

            <form className="itecform" onSubmit={formik.handleSubmit}>
                <Card className="client-card">
                    <CardContent className="client-heading">
                        <Typography variant="h5">Create Individual Client</Typography>
                    </CardContent>
                    <CardContent>
                        <Grid container spacing={3} className="main-container">
                            {/* {usertype === 'SUPERADMIN' ? (
                                <Grid item xs={12} sm={12}>
                                    <FormControl fullWidth>
                                        <InputLabel className="lbl" htmlFor="intclientName" shrink>
                                            {' '}
                                            Choose intermediary Client <span style={{ color: '#ff0a047a' }}>*</span>
                                        </InputLabel>

                                        <Select
                                            native
                                            className="bottom "
                                            name="intclientName"
                                            onChange={setImc}
                                            // value={selectedImc}
                                        >
                                            <option value="" selected disabled hidden>
                                                Select Client
                                            </option>
                                            {allImcsOptions(AllImcs)}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            ) : (
                                ''
                            )} */}

                            {/* <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <ul className="genderli radioalignment">
                                        <li>
                                            <div className="custom-control">
                                                <input
                                                    id="Individual"
                                                    type="radio"
                                                    value="Individual"
                                                    // name="gender"
                                                    onChange={handleRoleChange}
                                                    defaultValue="Individual"
                                                    checked="true"
                                                />
                                                <label className="custom-control-label" htmlFor="Individual">
                                                    Individual
                                                </label>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="custom-control">
                                                <input
                                                    id="Corporate"
                                                    type="radio"
                                                    value="Corporate"
                                                    // name="gender"
                                                    onChange={handleRoleChange}
                                                    // defaultChecked={formik.values.gender === 'Corporate'}
                                                />
                                                <label className="custom-control-label" htmlFor="Corporate">
                                                    Corporate
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </FormControl>
                            </Grid> */}

                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="firstname" shrink>
                                        {' '}
                                        First Name <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        name="firstname"
                                        type="text"
                                        placeholder="Enter Name"
                                        className="bottom"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.firstname}
                                    />
                                    {formik.touched.firstname && formik.errors.firstname ? (
                                        <span className="itec-validationError">{formik.errors.firstname}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="lastname" shrink>
                                        {' '}
                                        Last Name <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Name"
                                        className="bottom"
                                        name="lastname"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.lastname}
                                    />
                                    {formik.touched.lastname && formik.errors.lastname ? (
                                        <span className="itec-validationError">{formik.errors.lastname}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="addressline1" shrink>
                                        {' '}
                                        Address line 1 <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Address"
                                        className="bottom"
                                        name="addressline1"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.addressline1}
                                    />
                                    {formik.touched.addressline1 && formik.errors.addressline1 ? (
                                        <span className="itec-validationError">{formik.errors.addressline1}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="addressline2" shrink>
                                        {' '}
                                        Address line 2 <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Address"
                                        className="bottom"
                                        name="addressline2"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.addressline2}
                                    />
                                    {formik.touched.addressline2 && formik.errors.addressline2 ? (
                                        <span className="itec-validationError">{formik.errors.addressline2}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="country" shrink>
                                        {' '}
                                        Country <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Select
                                        native
                                        onChange={(e) => {
                                            setCountry(e);
                                            formik.handleChange(e);
                                        }}
                                        name="country"
                                        className="bottom"
                                        onBlur={formik.handleBlur}
                                        value={selectedCountry}
                                    >
                                        <option value="">Select Country</option>
                                        {allCountryOptions(allCountries)}
                                    </Select>
                                    {formik.touched.country && formik.errors.country ? (
                                        <span className="itec-validationError">{formik.errors.country}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="state" shrink>
                                        {' '}
                                        State <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Select
                                        native
                                        className="bottom"
                                        name="state"
                                        value={selectedState}
                                        onChange={(e) => {
                                            setState(e);
                                            formik.handleChange(e);
                                        }}
                                        onBlur={formik.handleBlur}
                                    >
                                        <option value="">Select State</option>
                                        {allStateOptions(allStates)}
                                    </Select>
                                    {formik.touched.state && formik.errors.state ? (
                                        <span className="itec-validationError">{formik.errors.state}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="city" shrink>
                                        {' '}
                                        City <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>

                                    <Select
                                        native
                                        name="city"
                                        className="bottom"
                                        value={selectedCity}
                                        onChange={(e) => {
                                            setCity(e);
                                            formik.handleChange(e);
                                        }}
                                        onBlur={formik.handleBlur}
                                    >
                                        <option value="">Select City</option>
                                        {allCityOptions(allCities)}
                                    </Select>
                                    {formik.touched.city && formik.errors.city ? (
                                        <span className="itec-validationError">{formik.errors.city}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="pin" shrink>
                                        {' '}
                                        Pin <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Pin"
                                        className="bottom"
                                        maxLength="6"
                                        name="pin"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.pin}
                                    />
                                    {formik.touched.pin && formik.errors.pin ? (
                                        <span className="itec-validationError">{formik.errors.pin}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="primarymobilenumber" shrink>
                                        {' '}
                                        Primary Mobile Number <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Mobile Number"
                                        className="bottom"
                                        name="primarymobilenumber"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.primarymobilenumber}
                                    />
                                    {formik.touched.primarymobilenumber && formik.errors.primarymobilenumber ? (
                                        <span className="itec-validationError">{formik.errors.primarymobilenumber}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="personalemailid" shrink>
                                        {' '}
                                        Personal Mail-Id <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Personal Mail-Id"
                                        className="bottom"
                                        name="personalemailid"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.personalemailid}
                                    />
                                    {formik.touched.personalemailid && formik.errors.personalemailid ? (
                                        <span className="itec-validationError">{formik.errors.personalemailid}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="dob" shrink>
                                        {' '}
                                        Date of Birth <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    {/* <DatePicker
                                        controls={['date']}
                                    /> */}
                                    <TextField
                                        type="date"
                                        name="dob"
                                        margin="normal"
                                        // format="YYYY-MM-DD"
                                        className={classes.textField}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.dob}
                                        // inputProps={{ max: "9999-12-31" }}
                                        InputProps={{ inputProps: { max: moment(new Date()).format('YYYY-MM-DD') } }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {formik.touched.dob && formik.errors.dob ? (
                                        <span className="itec-validationError">{formik.errors.dob}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="pan" shrink>
                                        {' '}
                                        PAN <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        onInput={toInputUppercase}
                                        type="text"
                                        placeholder="Enter PAN"
                                        className="bottom"
                                        name="pan"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.pan}
                                    />
                                    <div className={classes.btnFieldPositionRight}>
                                        {attachedFilePan ? (
                                            <span style={{ marginRight: '7px' }} className="fileName">
                                                {attachedFilePan.substring(0, 15)}
                                                {attachedFilePan.length > 15 ? '...' : ''}
                                            </span>
                                        ) : null}
                                        {attachedFilePan ? (
                                            <span onClick={() => handlePreviewModal(URLValuePan)}>
                                                <Tooltip title="Preview">
                                                    <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                                </Tooltip>
                                            </span>
                                        ) : null}
                                        <Button onClick={handleClickPan} variant="outlined" color="primary" className={classes.uploadBtn}>
                                            Upload
                                        </Button>
                                        <Dialog
                                            onClose={handleClosePan}
                                            PaperProps={{
                                                className: 'QandADailogBox',
                                                style: { padding: '20px' },
                                            }}
                                            aria-labelledby="form-dialog-title"
                                            open={handleOpenPan}
                                            clear={clearDataPan}
                                        >
                                            <DialogTitle id="form-dialog-title">
                                                Upload File
                                                {/* <IconButton
                                                    aria-label="close"
                                                    className={classes.closeButton}
                                                    onClick={handleClosePan}
                                                >
                                                    <CloseIcon />
                                                </IconButton> */}
                                            </DialogTitle>
                                            <DialogContent style={{ textAlign: 'center' }}>
                                                <Button className="btnOrange" variant="outlined" component="label" color="default">
                                                    <i className="btnIcon">
                                                        <FontAwesomeIcon icon={faPlus} />
                                                    </i>{' '}
                                                    Add File
                                                    <input
                                                        onChange={(e) => isFileUploadPan(e.target.files)}
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        accept=".jpeg,.png,.csv,.zip,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                    />
                                                </Button>
                                                {/* <p className="fileName">{filenamePan}</p> */}
                                                {filenamePan ? (
                                                    <p className="fileName">
                                                        {filenamePan.substring(0, 15)}
                                                        {filenamePan.length > 15 ? '...' : ''}
                                                    </p>
                                                ) : null}

                                                {filenamePan ? (
                                                    isfileInvalidPan.length > 0 ? (
                                                        <p className="noteCss">Note: {isfileInvalidPan}</p>
                                                    ) : (
                                                        ''
                                                    )
                                                ) : null}
                                            </DialogContent>
                                            <p className="fileNameGreen">{uploadSuccessfullyPan}</p>
                                            <DialogActions className="paddingBtm txtCenter">
                                                <Button
                                                    className={isDisablePan ? classes.disableBtn : 'btnBluepop'}
                                                    onClick={fileUploadPan}
                                                    variant="contained"
                                                    disabled={isDisablePan}
                                                    component="label"
                                                    color="default"
                                                >
                                                    Upload
                                                </Button>
                                                <Button
                                                    className="btnBluepop"
                                                    onClick={handleClosePan}
                                                    variant="contained"
                                                    component="label"
                                                    color="default"
                                                >
                                                    Cancel
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </div>
                                    {formik.touched.pan && formik.errors.pan ? (
                                        <span className="itec-validationError">{formik.errors.pan}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>

                            {/* <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="govIDNumber" shrink>
                                        {' '}
                                        Aadhaar Number <span style={{ color: "#ff0a047a" }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Aadhaar Number"
                                        className="bottom"
                                        name="govIDNumber"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.govIDNumber}
                                    />
                                    <div className={classes.btnFieldPositionRight}>
                                        <href className="fileName">{filenameAadhar}</href>
                                        <Button
                                            onClick={handleClickAadhar}
                                            variant="outlined"
                                            color="primary"
                                            className={classes.uploadBtn}
                                        >
                                            Upload
                                            </Button>
                                        <Dialog
                                            onClose={handleCloseAadhar}
                                            PaperProps={{
                                                className: 'QandADailogBox',
                                                style: { padding: '20px' },
                                            }}
                                            aria-labelledby="form-dialog-title"
                                            open={handleOpenAadhar}
                                            clear={clearDataAadhar}
                                        >
                                            <DialogTitle id="form-dialog-title">
                                                Upload File
                                                    <IconButton
                                                    aria-label="close"
                                                    className={classes.closeButton}
                                                    onClick={handleCloseAadhar}
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                            </DialogTitle>
                                            <DialogContent style={{ textAlign: 'center' }}>

                                                <Button
                                                    className="btnOrange"
                                                    variant="outlined"
                                                    component="label"
                                                    color="default"
                                                >
                                                    <i className="btnIcon">
                                                        <FontAwesomeIcon icon={faPlus} />
                                                    </i>{' '}
                                                        Add File
                                                        <input
                                                        onChange={(e) => isFileUploadAadhar(e, e.target.files)}
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        accept=".jpeg,.png,.csv,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                    />
                                                </Button>
                                                <p className="fileName">{filenameAadhar}</p>
                                            </DialogContent>
                                            <p className="fileNameGreen">{uploadSuccessfullyAadhar}</p>
                                            <DialogActions className="paddingBtm txtCenter">
                                                <Button
                                                    className="btnBluepop"
                                                    onClick={fileUploadAadhar}
                                                    variant="contained"
                                                    disabled={isDisableAadhar}
                                                    component="label"
                                                    color="default"
                                                >
                                                    Upload
                                                    </Button>
                                                <Button
                                                    className="btnBluepop"
                                                    onClick={handleCloseAadhar}
                                                    variant="contained"
                                                    component="label"
                                                    color="default"
                                                >
                                                    Cancel
                                                    </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </div>
                                    {formik.touched.govIDNumber && formik.errors.govIDNumber ? (
                                        <span className="itec-validationError">{formik.errors.govIDNumber}</span>
                                    ) : null}
                                </FormControl>
                            </Grid> */}

                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Do you have Aadhaar Number? <span style={{ color: '#ff0a047a' }}>*</span>
                                    </Typography>
                                    <div>
                                        <FormControl component="fieldset">
                                            <RadioGroup
                                                defaultValue="Aadhaar Number"
                                                // aria-label="aadhar"
                                                id="govIDType"
                                                name="govIDType"
                                                onChange={formik.handleChange}
                                                className="radio-option"
                                                value={formik.values.govIDType}
                                                onBlur={formik.handleBlur}
                                            >
                                                <ul className={classes.inlineDisplay}>
                                                    <li>
                                                        <FormControlLabel
                                                            value="Aadhaar Number"
                                                            control={<StyledRadio />}
                                                            label="Aadhaar Number"
                                                            name="govIDType"
                                                        />
                                                    </li>
                                                    <li>
                                                        <FormControlLabel
                                                            value="Enrollment Number"
                                                            control={<StyledRadio />}
                                                            label="Enrollment number"
                                                            name="govIDType"
                                                        />
                                                    </li>
                                                    <li>
                                                        <FormControlLabel
                                                            value="Not Enrolled"
                                                            control={<StyledRadio />}
                                                            label="Not Enrolled"
                                                            name="govIDType"
                                                        />
                                                    </li>
                                                </ul>
                                            </RadioGroup>
                                        </FormControl>
                                        {formik.values.govIDType === 'Aadhaar Number' ? (
                                            <FormControl fullWidth>
                                                <InputLabel htmlFor="aadhar-number" shrink>
                                                    Aadhaar Number <span style={{ color: '#ff0a047a' }}>*</span>
                                                </InputLabel>
                                                <Input
                                                    className={classes.bottomLine}
                                                    id="Aadhaar Number"
                                                    name="govIDNumber"
                                                    placeholder="Enter Aadhaar Number"
                                                    value={formik.values.govIDNumber}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />

                                                {formik.touched.govIDNumber && formik.errors.govIDNumber ? (
                                                    <span className="validationError">{formik.errors.govIDNumber}</span>
                                                ) : null}

                                                {/* <div className="itec-attachbtndiv"> */}
                                                <div className={classes.btnFieldPositionRight}>
                                                    {attachedFileAadhar ? (
                                                        <span style={{ marginRight: '7px' }}>
                                                            {attachedFileAadhar.substring(0, 15)}
                                                            {attachedFileAadhar.length > 15 ? '...' : ''}
                                                        </span>
                                                    ) : null}
                                                    {attachedFileAadhar ? (
                                                        <span onClick={() => handlePreviewModal(URLValueAadhar)}>
                                                            <Tooltip title="Preview">
                                                                <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                                            </Tooltip>
                                                        </span>
                                                    ) : null}
                                                    <label htmlFor="raised-button-file">
                                                        <Button
                                                            onClick={handleClickAadhar}
                                                            color="primary"
                                                            variant="outlined"
                                                            className={classes.uploadBtn}
                                                        >
                                                            Upload
                                                        </Button>
                                                    </label>

                                                    <Dialog
                                                        onClose={handleCloseAadhar}
                                                        PaperProps={{
                                                            className: 'QandADailogBox',
                                                            style: { padding: '20px' },
                                                        }}
                                                        aria-labelledby="form-dialog-title"
                                                        open={handleOpenAadhar}
                                                        clear={clearDataAadhar}
                                                    >
                                                        <DialogTitle id="form-dialog-title">Upload File</DialogTitle>
                                                        <DialogContent style={{ textAlign: 'center' }}>
                                                            <Button
                                                                className="btnOrange"
                                                                variant="outlined"
                                                                component="label"
                                                                color="default"
                                                            >
                                                                <i className="btnIcon">
                                                                    <FontAwesomeIcon icon={faPlus} />
                                                                </i>{' '}
                                                                Add File
                                                                <input
                                                                    onChange={(e) => isFileUploadAadhar(e.target.files)}
                                                                    type="file"
                                                                    style={{ display: 'none' }}
                                                                    accept=".jpeg,.png,.csv,.zip,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                                />
                                                            </Button>
                                                            {filenameAadhar ? (
                                                                <p className="fileName">
                                                                    {filenameAadhar.substring(0, 15)}
                                                                    {filenameAadhar.length > 15 ? '...' : ''}
                                                                </p>
                                                            ) : null}
                                                            {/* <p className="fileName">{filenameAadhar}</p> */}
                                                            {filenameAadhar ? (
                                                                isfileInvalidAadhar.length > 0 ? (
                                                                    <p className="noteCss">Note: {isfileInvalidAadhar}</p>
                                                                ) : (
                                                                    ''
                                                                )
                                                            ) : null}
                                                        </DialogContent>
                                                        <p className="fileNameGreen">{uploadSuccessfullyAadhar}</p>
                                                        <DialogActions className="paddingBtm txtCenter">
                                                            <Button
                                                                className={isDisableAadhar ? classes.disableBtn : 'btnBluepop'}
                                                                onClick={fileUploadAadhar}
                                                                variant="contained"
                                                                disabled={isDisableAadhar}
                                                                component="label"
                                                                color="default"
                                                            >
                                                                Upload
                                                            </Button>
                                                            <Button
                                                                className="btnBluepop"
                                                                onClick={handleCloseAadhar}
                                                                variant="contained"
                                                                component="label"
                                                                color="default"
                                                            >
                                                                Cancel
                                                            </Button>
                                                        </DialogActions>
                                                    </Dialog>
                                                </div>
                                            </FormControl>
                                        ) : formik.values.govIDType === 'Enrollment Number' ? (
                                            <FormControl fullWidth>
                                                <InputLabel htmlFor="aadhar-number" shrink>
                                                    Enrollment Number
                                                </InputLabel>
                                                <Input
                                                    className={classes.bottomLine}
                                                    id="Enrollment Number"
                                                    name="enrollmentNo"
                                                    placeholder="Enter Enrollment Number"
                                                    value={formik.values.enrollmentNo}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />

                                                {formik.touched.enrollmentNo && formik.errors.enrollmentNo ? (
                                                    <span className="validationError">{formik.errors.enrollmentNo}</span>
                                                ) : null}
                                                {/* <div className="itec-attachbtndiv"> */}
                                                <div className={classes.btnFieldPositionRight}>
                                                    {attachedFileEnrollment ? (
                                                        <span style={{ marginRight: '7px' }}>
                                                            {attachedFileEnrollment.substring(0, 15)}
                                                            {attachedFileEnrollment.length > 15 ? '...' : ''}
                                                        </span>
                                                    ) : null}
                                                    {/* <span style={{ marginRight: '7px' }}>{attachedFileEnrollment}</span> */}
                                                    {attachedFileEnrollment ? (
                                                        <span onClick={() => handlePreviewModal(URLValueEnrollment)}>
                                                            <Tooltip title="Preview">
                                                                <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                                            </Tooltip>
                                                        </span>
                                                    ) : null}
                                                    <Button
                                                        onClick={handleClickNew}
                                                        variant="outlined"
                                                        color="primary"
                                                        className={classes.uploadBtn}
                                                    >
                                                        Upload
                                                    </Button>
                                                    <Dialog
                                                        onClose={handleCloseNew}
                                                        PaperProps={{
                                                            className: 'QandADailogBox',
                                                            style: { padding: '20px' },
                                                        }}
                                                        aria-labelledby="form-dialog-title"
                                                        open={handleOpenNew}
                                                        clear={clearDataNew}
                                                    >
                                                        <DialogTitle id="form-dialog-title">
                                                            Upload File
                                                            {/* <IconButton
                                                                aria-label="close"
                                                                className={classes.closeButton}
                                                                onClick={handleCloseNew}
                                                            >
                                                                <CloseIcon />
                                                            </IconButton> */}
                                                        </DialogTitle>
                                                        <DialogContent style={{ textAlign: 'center' }}>
                                                            <Button
                                                                className="btnOrange"
                                                                variant="outlined"
                                                                component="label"
                                                                color="default"
                                                            >
                                                                <i className="btnIcon">
                                                                    <FontAwesomeIcon icon={faPlus} />
                                                                </i>{' '}
                                                                Add File
                                                                <input
                                                                    onChange={(e) => isFileUploadNew(e.target.files)}
                                                                    type="file"
                                                                    style={{ display: 'none' }}
                                                                    accept=".jpeg,.png,.csv,.zip,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                                />
                                                            </Button>
                                                            {filenameNew ? (
                                                                <p className="fileName">
                                                                    {filenameNew.substring(0, 15)}
                                                                    {filenameNew.length > 15 ? '...' : ''}
                                                                </p>
                                                            ) : null}
                                                            {/* <p className="fileName">{filenameNew}</p> */}
                                                            {filenameNew ? (
                                                                isfileInvalidNew.length > 0 ? (
                                                                    <p className="noteCss">Note: {isfileInvalidNew}</p>
                                                                ) : (
                                                                    ''
                                                                )
                                                            ) : null}
                                                        </DialogContent>
                                                        <p className="fileNameGreen">{uploadSuccessfullyNew}</p>
                                                        <DialogActions className="paddingBtm txtCenter">
                                                            <Button
                                                                className={isDisableNew ? classes.disableBtn : 'btnBluepop'}
                                                                onClick={fileUploadNew}
                                                                variant="contained"
                                                                disabled={isDisableNew}
                                                                component="label"
                                                                color="default"
                                                            >
                                                                Upload
                                                            </Button>
                                                            <Button
                                                                className="btnBluepop"
                                                                onClick={handleCloseNew}
                                                                variant="contained"
                                                                component="label"
                                                                color="default"
                                                            >
                                                                Cancel
                                                            </Button>
                                                        </DialogActions>
                                                    </Dialog>
                                                </div>
                                            </FormControl>
                                        ) : null}
                                    </div>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="gstin" shrink>
                                        {' '}
                                        GSTIN
                                    </InputLabel>
                                    <Input
                                        onInput={toInputUppercase}
                                        type="text"
                                        placeholder="GSTIN"
                                        className="bottom"
                                        name="gstin"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.gstin}
                                    />
                                    {formik.touched.gstin && formik.errors.gstin ? (
                                        <span className="itec-validationError">{formik.errors.gstin}</span>
                                    ) : null}
                                    <div className={classes.btnFieldPositionRight}>
                                        {filenameGst ? (
                                            <span style={{ marginRight: '7px' }}>
                                                {filenameGst.substring(0, 15)}
                                                {filenameGst.length > 15 ? '...' : ''}
                                            </span>
                                        ) : null}
                                        {/* <span style={{ marginRight: '7px' }} className="fileName">
                                            {filenameGst}
                                        </span> */}
                                        {filenameGst ? (
                                            <span onClick={() => handlePreviewModal(URLValueGst)}>
                                                <Tooltip title="Preview">
                                                    <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                                </Tooltip>
                                            </span>
                                        ) : null}
                                        <Button onClick={handleClickGst} variant="outlined" color="primary" className={classes.uploadBtn}>
                                            Upload
                                        </Button>
                                        <Dialog
                                            onClose={handleCloseGst}
                                            PaperProps={{
                                                className: 'QandADailogBox',
                                                style: { padding: '20px' },
                                            }}
                                            aria-labelledby="form-dialog-title"
                                            open={handleOpenGst}
                                            clear={clearDataGst}
                                        >
                                            <DialogTitle id="form-dialog-title">
                                                Upload File
                                                {/* <IconButton
                                                    aria-label="close"
                                                    className={classes.closeButton}
                                                    onClick={handleCloseGst}
                                                >
                                                    <CloseIcon />
                                                </IconButton> */}
                                            </DialogTitle>
                                            <DialogContent style={{ textAlign: 'center' }}>
                                                <Button className="btnOrange" variant="outlined" component="label" color="default">
                                                    <i className="btnIcon">
                                                        <FontAwesomeIcon icon={faPlus} />
                                                    </i>{' '}
                                                    Add File
                                                    <input
                                                        onChange={(e) => isFileUploadGst(e.target.files)}
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        accept=".jpeg,.png,.csv,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                    />
                                                </Button>
                                                {filenameGst ? (
                                                    <p className="fileName">
                                                        {filenameGst.substring(0, 15)}
                                                        {filenameGst.length > 15 ? '...' : ''}
                                                    </p>
                                                ) : null}
                                                {/* <p className="fileName">{filenameGst}</p> */}
                                                {filenameGst ? (
                                                    isfileInvalidGst.length > 0 ? (
                                                        <p className="noteCss">Note: {isfileInvalidGst}</p>
                                                    ) : (
                                                        ''
                                                    )
                                                ) : null}
                                            </DialogContent>
                                            <p className="fileNameGreen">{uploadSuccessfullyGst}</p>
                                            <DialogActions className="paddingBtm txtCenter">
                                                <Button
                                                    className={isDisableGst ? classes.disableBtn : 'btnBluepop'}
                                                    onClick={fileUploadGst}
                                                    variant="contained"
                                                    disabled={isDisableGst}
                                                    component="label"
                                                    color="default"
                                                >
                                                    Upload
                                                </Button>
                                                <Button
                                                    className="btnBluepop"
                                                    disabled={uploadSuccessfullyPan.length}
                                                    onClick={handleCloseGst}
                                                    variant="contained"
                                                    component="label"
                                                    color="default"
                                                >
                                                    Cancel
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </div>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="govtRegNumber" shrink>
                                        {' '}
                                        Govt Registration Number
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Govt Registration Number"
                                        className="bottom"
                                        name="govtRegNumber"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.govtRegNumber}
                                    />
                                    {formik.touched.govtRegNumber && formik.errors.govtRegNumber ? (
                                        <span className="itec-validationError">{formik.errors.govtRegNumber}</span>
                                    ) : null}
                                    <div className={classes.btnFieldPositionRight}>
                                        {/* <href className="fileName">{filenameReg}</href>
                                        <Button
                                            onClick={handleClickReg}
                                            variant="outlined"
                                            color="primary"
                                            className={classes.uploadBtn}
                                        >
                                            Upload
                                            </Button> */}
                                        <Dialog
                                            onClose={handleCloseReg}
                                            PaperProps={{
                                                className: 'QandADailogBox',
                                                style: { padding: '20px' },
                                            }}
                                            aria-labelledby="form-dialog-title"
                                            open={handleOpenReg}
                                            clear={clearDataReg}
                                        >
                                            <DialogTitle id="form-dialog-title">
                                                Upload File
                                                {/* <IconButton
                                                    aria-label="close"
                                                    className={classes.closeButton}
                                                    onClick={handleCloseReg}
                                                >
                                                    <CloseIcon />
                                                </IconButton> */}
                                            </DialogTitle>
                                            <DialogContent style={{ textAlign: 'center' }}>
                                                <Button className="btnOrange" variant="outlined" component="label" color="default">
                                                    <i className="btnIcon">
                                                        <FontAwesomeIcon icon={faPlus} />
                                                    </i>{' '}
                                                    Add File
                                                    <input
                                                        onChange={(e) => isFileUploadReg(e.target.files)}
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        accept=".jpeg,.png,.csv,.zip,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                    />
                                                </Button>
                                                <p className="fileName">{filenameReg}</p>
                                            </DialogContent>
                                            <p className="fileNameGreen">{uploadSuccessfullyReg}</p>
                                            <DialogActions className="paddingBtm txtCenter">
                                                <Button
                                                    className={isDisableReg ? classes.disableBtn : 'btnBluepop'}
                                                    onClick={fileUploadReg}
                                                    variant="contained"
                                                    disabled={isDisableReg}
                                                    component="label"
                                                    color="default"
                                                >
                                                    Upload
                                                </Button>
                                                <Button
                                                    className="btnBluepop"
                                                    disabled={uploadSuccessfullyAadhar.length}
                                                    onClick={handleCloseReg}
                                                    variant="contained"
                                                    component="label"
                                                    color="default"
                                                >
                                                    Cancel
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </div>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="prefComm" shrink>
                                        {' '}
                                        Preferred mode of communication <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Multiselect
                                        options={prefCommOptions}
                                        selectedValues={formik.values.prefComm}
                                        onSelect={onSelect}
                                        onRemove={onRemove}
                                        displayValue="name"
                                        showCheckbox={true}
                                        closeOnSelect={false}
                                        placeholder="Select"
                                        showArrow={true}
                                    />
                                    {/* <Select
                                        native
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        inputProps={{
                                            name: 'prefComm',
                                        }}
                                        className="bottom"
                                    >
                                        <option value="" selected disabled hidden>
                                            Select mode of communication
                                        </option>
                                        <option value="Email">Email</option>
                                        <option value="Mobile">Mobile</option>
                                    </Select> */}
                                    {/* {formik.touched.commArr && formik.errors.commArr ? (
                                        <span className="itec-validationError">{formik.errors.commArr}</span>
                                    ) : null} */}
                                    {formik.touched.prefComm && formik.errors.prefComm ? (
                                        <span className="itec-validationError">{formik.errors.prefComm}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="prefLang" shrink>
                                        {' '}
                                        Preferred language of communication <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Multiselect
                                        options={prefLangOptions}
                                        selectedValues={formik.values.prefLang}
                                        onSelect={onSelectLang}
                                        onRemove={onRemoveLang}
                                        displayValue="name"
                                        showCheckbox={true}
                                        closeOnSelect={false}
                                        placeholder="Select"
                                        showArrow={true}
                                    />
                                    {formik.touched.prefLang && formik.errors.prefLang ? (
                                        <span className="itec-validationError">{formik.errors.prefLang}</span>
                                    ) : null}
                                    {/* <Select
                                        native
                                        onChange={formik.handleChange}
                                        inputProps={{
                                            name: 'prefLang',
                                        }}
                                        className="bottom"
                                        onBlur={formik.handleBlur}
                                    >
                                        <option value="" selected disabled hidden>
                                            Select Language
                                        </option>
                                        <option value="English">English</option>
                                        <option value="Kannada">Kannada</option>
                                        <option value="Hindi">Hindi</option>
                                    </Select> */}
                                    {/* {formik.touched.langArr && formik.errors.langArr ? (
                                        <span className="itec-validationError">{formik.errors.langArr}</span>
                                    ) : null} */}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="website" shrink>
                                        {' '}
                                        Website
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Website URL"
                                        className="bottom"
                                        name="website"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.website}
                                    />
                                    {formik.touched.website && formik.errors.website ? (
                                        <span className="itec-validationError">{formik.errors.website}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <div className="designtext headingspace">Digital Signature details</div>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="dsc1PersonName" shrink>
                                        {' '}
                                        Name of the person
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Name of the person"
                                        className="bottom"
                                        name="dsc1PersonName"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.dsc1PersonName}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="dsc1StartDate" shrink>
                                        {' '}
                                        Validity start date
                                    </InputLabel>
                                    <Input
                                        type="date"
                                        className="bottom"
                                        format="YYYY-MM-DD"
                                        name="dsc1StartDate"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.dsc1StartDate}
                                        inputProps={{ max: '9999-12-31' }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="dsc1EndDate" shrink>
                                        {' '}
                                        Validity end date
                                    </InputLabel>
                                    <Input
                                        type="date"
                                        className="bottom"
                                        name="dsc1EndDate"
                                        format="YYYY-MM-DD"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.dsc1EndDate}
                                        inputProps={{ max: '9999-12-31' }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {formik.touched.dsc1EndDate && formik.errors.dsc1EndDate ? (
                                        <span className="itec-validationError">{formik.errors.dsc1EndDate}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="dsc1Password" shrink>
                                        {' '}
                                        Password
                                    </InputLabel>
                                    <Input
                                        type={values.showPassword ? 'password' : 'text'}
                                        placeholder="Enter Password"
                                        className="bottom"
                                        name="dsc1Password"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.dsc1Password}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={() => setValues({ showPassword: !values.showPassword })}
                                                >
                                                    {values.showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Whether physically available with us?
                                    </Typography>
                                    <div>
                                        <FormControl component="fieldset">
                                            <RadioGroup
                                                defaultValue="YES"
                                                // aria-label="aadhar"
                                                id="dsc1Physical"
                                                name="dsc1Physical"
                                                onChange={formik.handleChange}
                                                className="radio-option"
                                                value={formik.values.dsc1Physical}
                                                onBlur={formik.handleBlur}
                                            >
                                                <ul className={classes.inlineDisplay}>
                                                    <li>
                                                        <FormControlLabel
                                                            value="YES"
                                                            control={<StyledRadio />}
                                                            label="Yes"
                                                            // name="govIDType"
                                                        />
                                                    </li>
                                                    <li>
                                                        <FormControlLabel
                                                            value="NO"
                                                            control={<StyledRadio />}
                                                            label="No"
                                                            // name="govIDType"
                                                        />
                                                    </li>
                                                </ul>
                                            </RadioGroup>
                                        </FormControl>
                                    </div>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Grid>
                    <div className="footer-button">
                        <ul>
                            <li>
                                <div className="errorMsgRed">{errormsg}</div>
                                <PreviewModal fileSource={downloadFile} visibleClose={visible} handleModalClose={handleModalClose} />
                                {showBtnLoader ? (
                                    <LoaderPopUp
                                        showLoader={showBtnLoader}
                                        handleClose={handleClose}
                                        title="Please wait while approving Draft Statements"
                                    />
                                ) : null}
                                {/* {(showBtnLoader && (
                                    <Button color="primary" className="txt-capitalize butnImp buttonnext" disabled>
                                        <CircularProgress size={20} />
                                    </Button>
                                )) || (
                                    <Button color="primary" type="submit" className="txt-capitalize buttonnext">
                                        Create Client
                                    </Button>
                                )} */}
                                {(showLoader ? (
                                    <LoaderPopUp
                                        showLoader={showLoader}
                                        handleClose={handleClose}
                                        title="Please wait while we create the client"
                                    />
                                ) : null) || <ButtonComp type="submit" className="intermediarybutn" title="Create Client" />}
                            </li>
                        </ul>
                    </div>
                </Grid>
            </form>

            <div className="divideritecmaindiv dividermargin">
                <div className="divideritecdiv1">
                    <hr className="dividertag" />
                </div>
                <div className="designtext">OR</div>
                <div className="divideritecdiv1">
                    <hr className="dividertag" />
                </div>
            </div>
            <form className="itecform">
                <Card className="client-card">
                    <CardContent className="client-heading">
                        {/* <span className="heading"> Upload Employees Detail </span>
                        <span className="itec-downloadtext">  &emsp;  Download sample format for onboarding employees</span> */}
                        <span className="heading"> Upload Clients Details </span>
                    </CardContent>

                    <CardContent>
                        <Grid container spacing={3} className="main-container">
                            {/* <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="intclientName" shrink>
                                        {' '}
                                        Choose Client Type
                                    </InputLabel>
                                    <Select
                                        native
                                        className="bottom "
                                        name="intclientName"
                                        onChange={setImc}
                                        // value={selectedImc}
                                    >
                                        <option value="" selected disabled hidden>
                                            Select Client
                                        </option>
                                        {allImcsOptions(AllImcs)}
                                    </Select>
                                </FormControl>
                            </Grid> */}
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                className="intermediarybtnfontsize itec-bottombtndiv"
                                style={{ placeContent: 'flex-start' }}
                            >
                                {/* <div className="buttonwidth">
                                    <FormControl fullWidth>
                                        <a
                                            // href="../data/ultimate_individual_format.csv"
                                            href={downloadformat}
                                            download="ultimate_individual_format.csv"
                                            className="underline"
                                        >
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                component="span"
                                                color="primary"
                                                className="intermediarybtn"
                                                title="Download format"
                                            >
                                                Download format
                                            </Button>
                                        </a>
                                        <span className="itec-downloadtext">Download sample format for onboarding clients</span>
                                    </FormControl>
                                </div> */}
                                <div>
                                    {/* Click on the <a href={downloadformat}>link to download an empty client list file</a>. */}
                                    Click on the <a href={downloadformat}>link to download an empty client list file</a> as an excel
                                    spreadsheet. Fill up the excel spreadsheet with list of client. Use &#8220;File &#8211;&#062; Save
                                    as&#8221; options to save as .CSV.
                                </div>
                            </Grid>

                            {/* {usertype === 'SUPERADMIN' ? (
                                <Grid item xs={12} sm={5}>
                                    <FormControl fullWidth>
                                        <InputLabel className="lbl" htmlFor="intclientName" shrink>
                                            {' '}
                                            Choose intermediary Client <span style={{ color: '#ff0a047a' }}>*</span>
                                        </InputLabel>

                                        <Select
                                            native
                                            className="bottom "
                                            name="intclientName"
                                            onChange={setImc}
                                        // value={selectedImc}
                                        >
                                            <option value="" selected disabled hidden>
                                                Select Client
                                            </option>
                                            {allImcsOptions(AllImcs)}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            ) : (
                                    ''
                                )} */}
                            {/* {usertype === 'SUPERADMIN' ? <Grid item xs={12} sm={2} /> : ''} */}
                            <Grid
                                item
                                xs={12}
                                sm={5}
                                className="intermediarybtnfontsize itec-bottombtndiv"
                                style={{ placeContent: 'flex-start' }}
                            >
                                <div className="buttonwidth">
                                    <FormControl fullWidth>
                                        <label htmlFor="raised-button-file">
                                            <InputLabel className="lbl" htmlFor="intclientName" shrink>
                                                {' '}
                                                Upload list of clients in CSV format
                                            </InputLabel>
                                            <Button
                                                startIcon={<AttachFileIcon />}
                                                onClick={handleClick}
                                                variant="outlined"
                                                color="primary"
                                                className="intermediarybtn"
                                                style={{ position: 'relative', top: '22px' }}
                                            >
                                                Attach Updated Document
                                            </Button>
                                        </label>
                                        <Dialog
                                            onClose={handleClose}
                                            PaperProps={{
                                                className: 'QandADailogBox',
                                                style: { padding: '20px' },
                                            }}
                                            aria-labelledby="form-dialog-title"
                                            open={handleOpen}
                                            clear={clearData}
                                        >
                                            <DialogTitle id="form-dialog-title">Upload File</DialogTitle>
                                            <DialogContent style={{ textAlign: 'center' }}>
                                                <DialogContentText>Upload the updated client list</DialogContentText>

                                                <Button
                                                    className="btnOrange"
                                                    disabled={isDisableAddFile}
                                                    variant="outlined"
                                                    component="label"
                                                    color="default"
                                                >
                                                    <i className="btnIcon">
                                                        <FontAwesomeIcon icon={faPlus} />
                                                    </i>{' '}
                                                    Add File
                                                    <input
                                                        onChange={(e) => isFileUpload(e.target.files)}
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        accept=".csv,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf/image/*"
                                                    />
                                                </Button>
                                                {filename ? (
                                                    <p className="fileName">
                                                        {filename.substring(0, 15)}
                                                        {filename.length > 15 ? '...' : ''}
                                                    </p>
                                                ) : null}
                                                <p className="errorMsg">{isfileInvalid}</p>
                                                <div style={{ display: catchErrorDiv }}>
                                                    <p className="errorMsg">{fileuploadMsg400Error}</p>
                                                </div>
                                                <p className="errorMsg">{lengthSuccess}</p>
                                                <p className="errorMsg">{length}</p>
                                            </DialogContent>

                                            <DialogActions className="paddingBtm txtCenter">
                                                {showLoader ? <LoaderPopUp showLoader={showLoader} /> : null}
                                                <Button
                                                    className={isDisable ? classes.disableBtn : 'btnBluepop'}
                                                    onClick={fileUpload}
                                                    variant="contained"
                                                    disabled={isDisable}
                                                    component="label"
                                                    color="default"
                                                >
                                                    Upload
                                                </Button>
                                                <Button
                                                    className="btnBluepop"
                                                    onClick={handleClose}
                                                    variant="contained"
                                                    component="label"
                                                    color="default"
                                                >
                                                    Cancel
                                                </Button>
                                            </DialogActions>
                                            <div className="statusTbl" style={{ display: otpDiv }}>
                                                <TableContainer className="container">
                                                    <Table stickyHeader aria-label="sticky table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>Sl No</TableCell>
                                                                <TableCell>User Email</TableCell>
                                                                <TableCell>Status</TableCell>
                                                                <TableCell>Message</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {fileuploadMsgError.map((row, index) => (
                                                                <TableRow hover role="checkbox">
                                                                    <TableCell>{index + 1}</TableCell>
                                                                    <TableCell>{row.email}</TableCell>
                                                                    <TableCell>{row.status}</TableCell>
                                                                    <TableCell>
                                                                        {row.status === 'SUCCESS' ? 'SUCCESS' : row.message.join(',\n')}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>
                                        </Dialog>
                                    </FormControl>
                                </div>
                            </Grid>
                        </Grid>
                        {showLoader ? (
                            <LoaderPopUp
                                showLoader={showLoader}
                                disabled={isDisableSubmit}
                                handleClose={handleClose}
                                title="Please wait while we create the client"
                            />
                        ) : null}
                    </CardContent>
                </Card>
            </form>
            <Button variant="contained" onClick={() => back()} className="btnBlue txt-cap btnBckFloat" color="primary">
                Back
            </Button>
        </>
    );
}
